
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class PetalStormEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const speed = (1 + layerIndex * 0.5) * 200 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        for (let x = x1; x <= x2; x += spacing / 2) {
            const driftP = this.pseudoRandom(x);
            const scrollX = (time * speed) % spacing;
            const scrollY = (time * speed * 0.3) % spacing;
            const sway = Math.sin(time + x * 0.1) * 20;
            
            for (let y = y1; y <= y2; y += spacing / 2) {
                const size = (4 + driftP * 8) * scale;
                const rot = time * (1 + driftP) + x;
                
                const draw = () => {
                    ctx.save();
                    ctx.translate(x + scrollX + sway, y + scrollY);
                    ctx.rotate(rot);
                    ctx.beginPath();
                    ctx.ellipse(0, 0, size, size * 0.6, 0, 0, Math.PI * 2);
                    ctx.fill();
                    ctx.restore();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
